import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function DemoPage() {
  const [error, setError] = useState(null);

  useEffect(() => {
    const enter = async () => {
      try {
        // Reset walkthrough so the overlay shows fresh for this visitor
        localStorage.removeItem("arcscript_demo_walkthrough_complete");

        const { data } = await axios.get(`${API}/api/auth/demo-login`, {
          withCredentials: true,
        });

        // Full-page navigation so AuthContext re-initialises with the new cookie
        window.location.href = `/studio/${data.project_id}`;
      } catch (err) {
        console.error("Demo login failed:", err);
        setError("Something went wrong. Redirecting to sign-in…");
        setTimeout(() => {
          window.location.href = "/auth";
        }, 2000);
      }
    };

    enter();
  }, []);

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-4"
      style={{ background: "var(--surface-page)" }}
      data-testid="demo-loading"
    >
      {error ? (
        <p className="text-sm" style={{ color: "var(--ink-tertiary)" }}>
          {error}
        </p>
      ) : (
        <>
          {/* Fountain-pen pulse */}
          <div
            className="w-10 h-10 rounded-full"
            style={{
              background: "var(--accent-gold-soft)",
              border: "2px solid var(--accent-gold)",
              animation: "gold-pulse 1.5s ease-in-out infinite",
            }}
          />
          <p
            className="text-sm font-medium tracking-wide"
            style={{ color: "var(--ink-secondary)" }}
          >
            Entering the writing room…
          </p>
        </>
      )}
    </div>
  );
}
